<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">产品中心</div>
        <div class="item_small">-PRODUCT CONTER-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">{{ groupName }}</div>
        </div>
      </div>
      <div class="acea-row row-column row-center-wrapper kwh_top_edit_box">
        <img src="@/assets/productConter/kwh_top_edit_img.png" alt="">
      </div>
      <div class="productList_content row-column acea-row row-center-wrapper">
        <productList :productList="productList"></productList>
      </div>
    </div>
  </div>
</template>
<script>
import productList from "@/components/productList2/index";
export default {
  name: "qualifications",
  data() {
    return {
      topHeaderImg: require("@/assets/productConter/topbg1.png"),
      groupName: "智慧用电管理终端2", //产品类型名称
      productList: [
      {
          name: "PS-NA2",
          productImg: require("@/assets/productConter/goods/kwh_good4.png"),
          paramsImg: require("@/assets/productConter/params/PS-NA2.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PS-NA2.png"),
          size: "138*96*65",
          tableDataRight:[
            {technicalIndicators:"工作电压:",performanceDesc:'超宽的工作电压,160-400v AC安全工作电压'},
            {technicalIndicators:"防雷保护:",performanceDesc:'8/20US 10KA'},
            {technicalIndicators:"渴电保护:",performanceDesc:'漏电电流值可在线灵活设置，0-100ma可调控漏电0.02秒立断'},
            {technicalIndicators:"电压保护:",performanceDesc:'过压保护,保护电压可在线灵活设置。默认过压电压28OV欠压保护,保护电压可在线灵活设置。默认欠压电压18ov'},
            {technicalIndicators:"用电量统计:",performanceDesc:'高精度的月度用电量统计分辨率0.001-1kw/h可配置。默认O.lkw/h'},
            {technicalIndicators:"本地显示:",performanceDesc:'高清段式液晶屏实时显示电压,电流,用电量,故障次数故障灯指示,网络指示灯和通讯指示灯'}
          ],
          tableDataLeft:[
            {technicalIndicators:"本地显示:",performanceDesc:'高清段式液晶屏实时显示电压,电流,用电量，故障次数故障灯指示,网络指示灯和通讯指示灯'},
            {technicalIndicators:"定时控制:",performanceDesc:'实时时钟，可在线校准可灵活设置多组定时组合控制,最多可设置八组定时可设置年循环,月循环,日循环,星期循环,'},
            {technicalIndicators:"自动重合闸:",performanceDesc:'自动重合闸和不重合闸两种模式，可切换'},
            {technicalIndicators:"通讯方式:",performanceDesc:'TCP(10OM)高速通讯、支持TCP和RS485透传、支持CAT1 4G无线通讯'},
            {technicalIndicators:"支持CAT1 4G无线通讯",performanceDesc:'可选配温度监测,烟雾探测,GPS/北斗定位'},
            {technicalIndicators:"管理平台:",performanceDesc:'手机端、PC端双管理平台'}
          ]
        },
        {
          name: "PS-NA2/80A",
          productImg: require("@/assets/productConter/goods/kwh_good2.png"),
          paramsImg: require("@/assets/productConter/params/PS-NA2_80A.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PS-NA2_80A.png"),
          size: "138*96*65",
          tableDataRight:[
            {technicalIndicators:"工作电压:",performanceDesc:'超宽的工作电压，160-400v AC安全工作电压'},
            {technicalIndicators:"防雷保护:",performanceDesc:'8/20uS 10KA'},
            {technicalIndicators:"漏电保护:",performanceDesc:'漏电电流值可在线灵活设置，0-100ma可调控漏电0.02秒立断'},
            {technicalIndicators:"电压保护:",performanceDesc:'过压保护,保护电压可在线灵活设置。默认过压电压280V欠压保护,保护电压可在线灵活设置。默认欠压电压180v'},
            {technicalIndicators:"用电量统计:",performanceDesc:'高精度的月度用电量统计分辨率0.001-1kw/h可配置。默认0.1kw/h'},
            {technicalIndicators:"本地显示:",performanceDesc:'高清段式液晶屏实时显示电压,电流,用电量,故障次数故障灯指示,网络指示灯和通讯指示灯'}
          ],
          tableDataLeft:[
            {technicalIndicators:"定时控制:",performanceDesc:'实时时钟，可在线校准、可灵活设置多组定时组合控制,最多可设置八组定时可设置年循环,月循环,日循环,星期循环,单次执行'},
            {technicalIndicators:"自动重合闸:",performanceDesc:'自动重合闸和不重合闸两种模式，可切换'},
            {technicalIndicators:"通讯方式:",performanceDesc:'TCP{10OM)高速通讯、支持TCP和RS485透传、支持CAT14G无线通讯'},
            {technicalIndicators:"传感监测:",performanceDesc:'可选配温度监测,烟雾探测，GPS/北斗定位'},
            {technicalIndicators:"管理平台:",performanceDesc:'手机端、PC端双管理平台'}
          ]
        },
        {
          name: "PS-NA4",
          productImg: require("@/assets/productConter/goods/kwh_good1.png"),
          paramsImg: require("@/assets/productConter/params/PS-NA4.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PS-NA4.png"),
          size: "135*96*65",
          tableDataRight:[
            {technicalIndicators:"产品型号:",performanceDesc:'PS-NA4 **'},
            {technicalIndicators:"工作环境(温、湿度):",performanceDesc:'-40°C-85°C/≤80%'},
            {technicalIndicators:"外型尺寸(HxWxDmm):",performanceDesc:'135*96*65'},
            {technicalIndicators:"产品功能指示灯:",performanceDesc:'工作、通信'},
            {technicalIndicators:"分路指示灯:",performanceDesc:'K1、K2、K3、K4'},
            {technicalIndicators:"输入额定电压(工作电压波动范围):",performanceDesc:'220v(180V-280V)'},
            {technicalIndicators:"输入额定电压频率{含波动范围):",performanceDesc:'50Hz(±1Hz)'},
            {technicalIndicators:"额定电流(In):",performanceDesc:'分路K1:32A K2~K4:16A'},
            {technicalIndicators:"额定电流是否可调:",performanceDesc:'可调'},
            {technicalIndicators:"断开方式:",performanceDesc:'火线断开《L)'},
            {technicalIndicators:"过载保护值及动作时间:",performanceDesc:'>In*1.15,<2s'}
          ],
          tableDataLeft:[
            {technicalIndicators:"合闸方式:",performanceDesc:'定时合闸，手动合闸,远程合闸'},
            {technicalIndicators:"安装方式:",performanceDesc:'标准35mm导轨安装'},
            {technicalIndicators:"定时控制:",performanceDesc:'可灵活设置多组定时组合控制,最多可设置八组定时可设置年循环，月循环，日循环，星期循环，单次执行'},
            {technicalIndicators:"自动重合闸:",performanceDesc:'自动重合闸和不重合闸两种模式，可切换'},
            {technicalIndicators:"通讯方式:",performanceDesc:'TCP[100M)高速通讯、支持TCP和RS485透传、支持CAT14G无线通讯'},
            {technicalIndicators:"传感监测:",performanceDesc:'可选配温度监测，烟雾探测,GPS/北斗定位'},
            {technicalIndicators:"管理平台:",performanceDesc:'手机端、PC端双管理平台'},
          ]
        },
         {
          name: "PS-NA3/80A",
          productImg: require("@/assets/productConter/goods/kwh_good3.png"),
          paramsImg: require("@/assets/productConter/params/PS-NA3_80A.png"),
          paramsminiImg: require("@/assets/productConter/params/mini/PS-NA3_80A.png"),
          size: "150*110*65",
          tableDataRight:[
            {technicalIndicators:"工作电压:",performanceDesc:'超宽的工作电压,160-400v AC安全工作电压'},
            {technicalIndicators:"防雷保护:",performanceDesc:'8/20US 10KA'},
            {technicalIndicators:"渴电保护:",performanceDesc:'漏电电流值可在线灵活设置，0-100ma可调控漏电0.02秒立断'},
            {technicalIndicators:"电压保护:",performanceDesc:'过压保护,保护电压可在线灵活设置。默认过压电压28OV欠压保护,保护电压可在线灵活设置。默认欠压电压18ov'},
            {technicalIndicators:"用电量统计:",performanceDesc:'高精度的月度用电量统计分辨率0.001-1kw/h可配置。默认O.lkw/h'},
            {technicalIndicators:"本地显示:",performanceDesc:'高清段式液晶屏实时显示电压,电流,用电量,故障次数故障灯指示,网络指示灯和通讯指示灯'}
          ],
          tableDataLeft:[
            {technicalIndicators:"本地显示:",performanceDesc:'高清段式液晶屏实时显示电压,电流,用电量，故障次数故障灯指示,网络指示灯和通讯指示灯'},
            {technicalIndicators:"定时控制:",performanceDesc:'实时时钟，可在线校准可灵活设置多组定时组合控制,最多可设置八组定时可设置年循环,月循环,日循环,星期循环,'},
            {technicalIndicators:"自动重合闸:",performanceDesc:'自动重合闸和不重合闸两种模式，可切换'},
            {technicalIndicators:"通讯方式:",performanceDesc:'TCP(10OM)高速通讯、支持TCP和RS485透传、支持CAT1 4G无线通讯'},
            {technicalIndicators:"支持CAT1 4G无线通讯",performanceDesc:'可选配温度监测,烟雾探测,GPS/北斗定位'},
            {technicalIndicators:"管理平台:",performanceDesc:'手机端、PC端双管理平台'}
          ]
        },

      ],
    };
  },
  watch: {},
  components: {
    productList,
  },
  mounted: function () {},
};
</script>
<style scoped>
.content_box {
  width: 100%;

  background-color: #f3f3f3;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
.content_box .productList_content {
  padding: 20px 0px;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 0%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  color: #555555;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}
.kwh_top_edit_box img{
  width: 70%;
  height: 70%;
}

/* 关于我们 end */
.profile_content {
  color: #333333;
  font-size: 20px;
  width: 65%;
  line-height: 45px;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/productConter/kwh.vue